"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButtonWrapper = _interopRequireDefault(require("UIComponents/layout/UIButtonWrapper"));

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

var _PlaybooksActions = require("crm_data/playbooks/actions/PlaybooksActions");

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _CommunicatorConstants = require("crm_ui/components/profile/interactions/common/CommunicatorConstants");

var _loggers = require("customer-data-tracking/loggers");

var TIMELINE_FILTER_ENGAGEMENT_TYPES = _interopRequireWildcard(require("crm_ui/timeline/helpers/TimelineFilterEngagementTypes"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _CallSelectorsMenuWrapper = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/call/CallSelectorsMenuWrapper"));

var _generalStore = require("general-store");

var _CallProviderDependency = _interopRequireDefault(require("crm_ui/calling/dependencies/CallProviderDependency"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _eventLogger = require("customer-data-communicator/data/communicator/utils/eventLogger");

var _CommunicatorPageActions = require("customer-data-communicator/data/communicator/actions/CommunicatorPageActions");

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _TIMELINE_FILTER_ENGA;

var TIMELINE_FILTER_ENGAGEMENT_TYPES_TO_INTERACTION_TYPES = (_TIMELINE_FILTER_ENGA = {}, (0, _defineProperty2.default)(_TIMELINE_FILTER_ENGA, TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_NOTES, _InteractionTypes.NOTE), (0, _defineProperty2.default)(_TIMELINE_FILTER_ENGA, TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_EMAIL, _InteractionTypes.EMAIL), (0, _defineProperty2.default)(_TIMELINE_FILTER_ENGA, "LOGGED_ENGAGEMENTS_EMAILS_TRIMMED", _InteractionTypes.LOGGED_EMAIL), (0, _defineProperty2.default)(_TIMELINE_FILTER_ENGA, TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS, _InteractionTypes.CALL), (0, _defineProperty2.default)(_TIMELINE_FILTER_ENGA, "LOGGED_ENGAGEMENTS_CALLS", _InteractionTypes.LOGGED_CALL), (0, _defineProperty2.default)(_TIMELINE_FILTER_ENGA, TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_TASKS, _InteractionTypes.TASK), _TIMELINE_FILTER_ENGA);

var ProfileTimelineTabsCommunicatorButtons =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ProfileTimelineTabsCommunicatorButtons, _PureComponent);

  function ProfileTimelineTabsCommunicatorButtons(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProfileTimelineTabsCommunicatorButtons);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProfileTimelineTabsCommunicatorButtons).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      popoverOpen: false
    };
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(ProfileTimelineTabsCommunicatorButtons, [{
    key: "getCallWidget",
    value: function getCallWidget() {
      var callProvider = this.props.callProvider;

      if (callProvider !== undefined && callProvider.widgets.size) {
        return callProvider.widgets.get(0);
      }

      return undefined;
    }
  }, {
    key: "isCallPopoverEnabled",
    value: function isCallPopoverEnabled() {
      return this.getCallWidget();
    }
  }, {
    key: "handlePopoverOpenState",
    value: function handlePopoverOpenState(targetState) {
      this.setState({
        popoverOpen: targetState
      });
    }
  }, {
    key: "handleCommunicatorButtonClick",
    value: function handleCommunicatorButtonClick(isLogged) {
      var selected = this.props.selected;
      var _this$context = this.context,
          objectType = _this$context.objectType,
          subjectId = _this$context.subjectId;
      var selectedType = "" + (isLogged ? 'LOGGED_' : '') + selected;
      var type = TIMELINE_FILTER_ENGAGEMENT_TYPES_TO_INTERACTION_TYPES[selectedType];
      var openedFromCallPopover = [TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS].includes(selected) && this.isCallPopoverEnabled();
      (0, _CommunicatorActions.showCommunicator)(type);
      (0, _PlaybooksActions.conditionallyMinimizePlaybook)();
      (0, _eventLogger.logPageAction)({
        key: _CommunicatorPageActions.PageActions.COMMUNICATOR_TRIGGER_LOCATION,
        tags: {
          location: _CommunicatorConstants.TIMELINE_TAB
        }
      });
      this.handlePopoverOpenState(false);
      (0, _CommunicatorActions.setCommunicatorTriggerLocation)({
        triggerLocation: _CommunicatorConstants.TIMELINE_TAB,
        subjectIdContext: subjectId,
        objectTypeContext: objectType
      });
      var subActionLocation = openedFromCallPopover ? 'open call notes' : 'timeline tab';

      _loggers.CrmLogger.logRecordInteraction(objectType, {
        action: 'opened floating communicator',
        subAction: "clicked from " + subActionLocation,
        type: type
      });

      _loggers.CommunicatorLogger.log('communicatorInteraction', {
        action: 'open communicator',
        activity: type,
        channel: type === 'call' ? 'outbound call' : type,
        source: 'timeline'
      });
    }
  }, {
    key: "getButtonTextCreateButton",
    value: function getButtonTextCreateButton() {
      var selected = this.props.selected;

      switch (selected) {
        case TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_NOTES:
          return 'profileContentTimeline.tabCommunicatorButtons.ENGAGEMENTS_NOTES.createButton';

        case TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_EMAIL:
          return 'profileContentTimeline.tabCommunicatorButtons.ENGAGEMENTS_EMAILS_TRIMMED.createButton';

        case TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS:
          return 'profileContentTimeline.tabCommunicatorButtons.ENGAGEMENTS_CALLS.createButton';

        case TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_TASKS:
          return 'profileContentTimeline.tabCommunicatorButtons.ENGAGEMENTS_TASKS.createButton';

        default:
          return 'profileContentTimeline.tabCommunicatorButtons.default.createButton';
      }
    }
  }, {
    key: "getButtonTextLogButton",
    value: function getButtonTextLogButton() {
      var selected = this.props.selected;

      switch (selected) {
        case TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_EMAIL:
          return 'profileContentTimeline.tabCommunicatorButtons.ENGAGEMENTS_EMAILS_TRIMMED.logButton';

        case TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS:
          return 'profileContentTimeline.tabCommunicatorButtons.ENGAGEMENTS_CALLS.logButton';

        default:
          return 'profileContentTimeline.tabCommunicatorButtons.default.logButton';
      }
    }
  }, {
    key: "renderCallSelectorsMenu",
    value: function renderCallSelectorsMenu() {
      return _react.default.createElement(_CallSelectorsMenuWrapper.default, {
        source: "timeline",
        objectType: this.context.objectType,
        subjectId: this.context.subjectId,
        onCallButtonClick: this.partial(this.handleCommunicatorButtonClick, false)
      });
    }
  }, {
    key: "renderButtonWithPopover",
    value: function renderButtonWithPopover(props) {
      var _this2 = this;

      return _react.default.createElement(_UIPopover.default, {
        open: this.state.popoverOpen,
        closeOnOutsideClick: true,
        onOpenChange: function onOpenChange(evt) {
          return _this2.handlePopoverOpenState(evt.target.value);
        },
        content: {
          body: this.renderCallSelectorsMenu()
        },
        placement: "bottom left",
        arrowSize: "none",
        autoPlacement: false,
        closeOnTargetLeave: true
      }, this.renderCreateButton(props));
    }
  }, {
    key: "renderCreateButton",
    value: function renderCreateButton(_ref) {
      var canCommunicate = _ref.canCommunicate,
          shouldRenderCallPopover = _ref.shouldRenderCallPopover;
      var selected = this.props.selected;
      var message = this.getButtonTextCreateButton();
      return _react.default.createElement(_UIButton.default, {
        "data-selenium-test": selected + "_CREATE",
        "data-unit-test": selected + "_CREATE",
        use: "tertiary",
        size: "small",
        disabled: !canCommunicate,
        onClick: shouldRenderCallPopover ? this.partial(this.handlePopoverOpenState, !this.state.popoverOpen) : this.partial(this.handleCommunicatorButtonClick, false)
      }, _react.default.createElement(_FormattedMessage.default, {
        message: message
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var selected = this.props.selected;

      if (selected === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_ACTIVITY) {
        return null;
      }

      var shouldRenderLoggedButton = [TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS, TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_EMAIL].includes(selected);
      var shouldRenderCallPopover = [TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_CALLS].includes(selected) && this.isCallPopoverEnabled();
      var canCommunicate = this.props.hasCommunicatePermissions || selected === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_NOTES || selected === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_TASKS;
      var createButtonProps = {
        canCommunicate: canCommunicate,
        shouldRenderCallPopover: shouldRenderCallPopover
      };
      var logButtonText = this.getButtonTextLogButton();
      return _react.default.createElement(_UIButtonWrapper.default, {
        justify: "end",
        "data-selenium-test": "profileTimelineButton"
      }, shouldRenderLoggedButton && _react.default.createElement(_UIButton.default, {
        "data-selenium-test": selected + "_LOG",
        use: "tertiary-light",
        size: "small",
        disabled: !canCommunicate,
        onClick: this.partial(this.handleCommunicatorButtonClick, true)
      }, _react.default.createElement(_FormattedMessage.default, {
        message: logButtonText
      })), shouldRenderCallPopover ? this.renderButtonWithPopover(createButtonProps) : this.renderCreateButton(createButtonProps));
    }
  }]);
  return ProfileTimelineTabsCommunicatorButtons;
}(_PureComponent2.default);

ProfileTimelineTabsCommunicatorButtons.contextType = _SubjectContext.SubjectContext;
ProfileTimelineTabsCommunicatorButtons.propTypes = {
  callProvider: _propTypes.default.shape({
    widgets: _reactImmutableProptypes.default.list
  }),
  hasCommunicatePermissions: _propTypes.default.bool,
  selected: _propTypes.default.string.isRequired
};
ProfileTimelineTabsCommunicatorButtons.defaultProps = {
  hasCommunicatePermissions: false
};

var _default = (0, _generalStore.connect)({
  callProvider: _CallProviderDependency.default
})(ProfileTimelineTabsCommunicatorButtons);

exports.default = _default;
module.exports = exports.default;